import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../../../styles/colors';
import { MediaQueries } from '../../../../../styles/Grid';
import { typography, fontWeights } from '../../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../../utils/constants';

export const commonCss = css({
  marginTop: '36px',
  form: {
    marginTop: '24px',
    marginBottom: '0px',
    position: 'relative',

    button: {
      width: '120px',
      marginLeft: '16px',
      borderRadius: '8px',
      color: '#fff',
      background: '#E52500',
      outline: 'none',
    },

    '.callmesec': {
      display: 'flex',
      maxWidth: '418px',
      width: '100%',
      [MediaQueries.xl]: {
        maxWidth: '418px',
      },
      [MediaQueries.sm]: {
        display: 'block',
      },
      [MediaQueries.md]: {
        display: 'block',
      },

      [MediaQueries.lg]: {
        maxWidth: '456px',
      },

      '.inputphone': {
        width: '100%',
        label: {
          fontSize: '16px',
          div: {
            fontSize: '14px',
          },
        },
        span: {
          fontSize: '16px',
        },

        '#phoneNumber-helper-text': {
          position: 'absolute',
          fontSize: '14px',
          [MediaQueries.md]: {
            position: 'relative',
          },
          [MediaQueries.sm]: {
            position: 'relative',
          },
        },

        input: {
          fontSize: '16px',
          [MediaQueries.lg]: {},
          [MediaQueries.md]: {
            fontSize: '16px',
          },
        },
      },
      'button:hover': {
        background: '#d42705',
        outlineColor: '#d42705',
      },
      button: {
        borderRadius: '8px',
        fontSize: '14px',
        minHeight: '56px',
        cursor: 'pointer',
        display: 'flex',
        textTransform: 'uppercase',
        minWidth: '120px',
        lineHeight: '18px',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#E52500',
        marginLeft: '16px',
        color: '#fff',
        border: '0px',
        letterSpacing: '0.88px',

        [MediaQueries.sm]: {
          marginLeft: '0px',
          marginTop: '15px',
          minHeight: '56',
          width: '100%',
        },
        [MediaQueries.md]: {
          marginLeft: '0px',
          marginTop: '15px',
          minHeight: '56',
          width: '100%',
        },

        [MediaQueries.lg]: {
          minHeight: '56px',
        },
      },
    },
  },

  '.c1_call_sec': {
    marginTop: '24px',

    b: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
    },

    '.call_no': {
      display: 'flex',
      marginTop: '0px',
      alignItems: 'center',

      fontWeight: '500',

      a: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',

        i: {
          margin: '0px 10px 0px 24px',
        },
      },

      '.number': {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0px',
        textAlign: 'left',
      },
    },
  },
  h3: {
    fontSize: '28px',
    lineHeight: '40px',
    fontWeight: '500',
    letterSpacing: '-0.4000000059604645px',
    textAlign: 'left',
    [MediaQueries.md]: {
      fontSize: '22px',
      lineHeight: '24px',
    },
    [MediaQueries.sm]: {
      fontSize: '22px',
      lineHeight: '24px',
    },
  },

  p: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
  },
});

export const DarkModeCss = css({
  '.c1_call_sec': {
    color: '#fff',
  },

  a: {
    color: '#fff',
  },
});

export const LightModeCss = css({
  '.c1_call_sec': {
    color: '#393939',
  },

  a: {
    color: '#393939',
  },
});

export const msgBox = css({
  padding: '18px 0px 0px',
  display: 'none',
  color: colorsPalette.teal,
});
export const success = css({ color: colorsPalette.teal });
export const error = css({ color: colorsPalette.red });
